import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, mergeProps as _mergeProps, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"
import _imports_0 from '@/assets/img/icon/geocode-icon.svg'


const _hoisted_1 = { class: "agent-form" }
const _hoisted_2 = { class: "mb-4" }
const _hoisted_3 = { class: "flex align-items-center" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", {
  for: "isHjexAgent",
  class: "ml-2"
}, "Sambungkan dengan Agen HJEX", -1)
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { class: "mb-4" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "label-text required" }, "Nama Agen", -1)
const _hoisted_8 = { class: "invalid-feedback" }
const _hoisted_9 = { class: "mb-4" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "label-text required" }, "ID Agen", -1)
const _hoisted_11 = { class: "invalid-feedback" }
const _hoisted_12 = { class: "mb-4" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "label-text required" }, "Terminal", -1)
const _hoisted_14 = { class: "invalid-feedback" }
const _hoisted_15 = { class: "mb-4 overflow-x-auto" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "label-text required" }, "Alamat", -1)
const _hoisted_17 = { class: "flex gap-2 items-start mb-4" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  width: "15",
  class: "mt-1"
}, null, -1)
const _hoisted_19 = { class: "color-blue-1 text-sm" }
const _hoisted_20 = { key: 1 }
const _hoisted_21 = { class: "w-full mb-4" }
const _hoisted_22 = { class: "mb-4" }
const _hoisted_23 = { key: 0 }
const _hoisted_24 = { class: "mb-4" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { class: "text-base font-bold mb-3" }, "Identitas Agen:", -1)
const _hoisted_26 = { class: "md:flex w-full" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", { class: "w-full md:w-1/4 text-sm font-semibold" }, "Nama Agen:", -1)
const _hoisted_28 = { class: "w-full md:w-3/4 text-grey text-sm" }
const _hoisted_29 = { class: "md:flex w-full" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("div", { class: "w-full md:w-1/4 text-sm font-semibold" }, "Kode Agen:", -1)
const _hoisted_31 = { class: "w-full md:w-3/4 text-grey text-sm" }
const _hoisted_32 = { class: "md:flex w-full" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("div", { class: "w-full md:w-1/4 text-sm font-semibold" }, "Alamat:", -1)
const _hoisted_34 = { class: "w-full md:w-3/4 text-grey text-sm" }
const _hoisted_35 = { class: "md:flex w-full" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("div", { class: "w-full md:w-1/4 text-sm font-semibold" }, "Kota:", -1)
const _hoisted_37 = { class: "w-full md:w-3/4 text-grey text-sm" }
const _hoisted_38 = { class: "md:flex w-full" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("div", { class: "w-full md:w-1/4 text-sm font-semibold" }, "Lokasi Agen:", -1)
const _hoisted_40 = { class: "w-full md:w-3/4 text-grey text-sm" }
const _hoisted_41 = { class: "mb-4" }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("div", { class: "label-text required" }, "Terminal", -1)
const _hoisted_43 = { class: "invalid-feedback" }
const _hoisted_44 = { key: 1 }
const _hoisted_45 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_46 = {
  key: 1,
  class: "invalid-feedback"
}
const _hoisted_47 = { class: "mb-4" }
const _hoisted_48 = /*#__PURE__*/_createElementVNode("p", { class: "text-sm mb-1" }, "Aktif", -1)
const _hoisted_49 = { class: "container-btn-action" }
const _hoisted_50 = /*#__PURE__*/_createTextVNode("Kembali")
const _hoisted_51 = /*#__PURE__*/_createTextVNode("Simpan")

import InputText from 'primevue/inputtext'
import Button from 'primevue/button'
import Textarea from 'primevue/textarea'
import Checkbox from 'primevue/checkbox'
import { Form, Field } from 'vee-validate'
import vSelect from 'vue-select'
import * as Yup from 'yup'
import { useStore } from 'vuex'
import InputSwitch from 'primevue/inputswitch'
import { onMounted, getCurrentInstance, ref, computed } from 'vue'
import { IPartnerAgent } from '@/utils/interfaces/iPartnerAgent'
import apiUseCase from '@/usecase/apiUseCase'
import { isNull } from 'lodash'
import rgxExp from '@/utils/helpers/regExp'
import returnUrlPrams from '@/utils/helpers/returnUrlPrams'
import MapsSearch from '@/views/pages/master-setting/city-terminal/components/MapsSearch.vue'
import InputIconRight from '@/views/components/form/InputIconRight.vue'
import { hjexAgentUseCase } from '@/usecase/pages/agentUseCase'
import SelectFetch from '@/views/components/form/SelectAsync.vue'
import SelectFetchHjex from '@/views/components/form/SelectAsyncHjex.vue'
// import HjexAgentForm from '@/views/pages/master-setting/partner-agent/form/HjexAgentForm.vue'

type TFieldValue = {
  (field: string, value: any): void
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Form',
  setup(__props) {

const moduleStore = 'hjpTable'
const endpoint = '/management/v1/MsAgent'
const store = useStore()
const app = getCurrentInstance()
const {
  $toast, $icon
} = app!.appContext.config.globalProperties
const dataForm = ref()
const idPrams = computed(() => store.state[moduleStore].modal?.data?.Id)
const isHjexAgent = ref(false)
const inputSearch = ref('')
const address = ref('')
const icon = $icon

const initialValues: IPartnerAgent = {
  Name: store.state.hjpTable.modal.data ? store.state.hjpTable.modal.data.Name : '',
  IdAgent: store.state.hjpTable.modal.data ? store.state.hjpTable.modal.data.Code : '',
  Station: store.state.hjpTable.modal.data ? { ...store.state.hjpTable.modal.data.MsStation, label: `${store.state.hjpTable.modal.data.MsStation.CityName} - ${store.state.hjpTable.modal.data.MsStation.Name}`, value: store.state.hjpTable.modal.data.MsStation.Id } : null,
  Location: store.state.hjpTable.modal.data ? { Lat: store.state.hjpTable.modal.data.Latitude, Lng: store.state.hjpTable.modal.data.Longitude } : null,
  IsActive: store.state.hjpTable.modal.data ? store.state.hjpTable.modal.data.IsActive : true
}

const initialValuesAirport = {
  Data: store.state.hjpTable.modal.data ? store.state.hjpTable.modal.data.Data : null,
  Station: store.state.hjpTable.modal.data ? store.state.hjpTable.modal.data.MsStation : null,
  IsActive: store.state.hjpTable.modal.data ? store.state.hjpTable.modal.data.IsActive : true
}

const schema = Yup.object().shape({
  Name: Yup.string()
    .required('Nama Agen harus diisi!')
    .max(100, 'Nama Agen tidak boleh melebihi 100 karakter')
    .matches(rgxExp.notPrefixSpace, 'Nama Agen tidak boleh diawali dengan spasi')
    .test('unique-name', 'Nama Agen sudah digunakan', async (val) => {
      if (!val) return true
      try {
        const res = await apiUseCase.get(`${endpoint}${returnUrlPrams({
          search: val,
          filterField: ['name']
        })}`)
        const filterResult = res.result.filter((x: any) => x.Name === val)
        if (idPrams.value) {
          return filterResult.length === 0 || val === initialValues.Name
        } return filterResult.length === 0
      } catch (error) {
        return false
      }
    }),
  IdAgent: Yup.string().required('Id Agen harus diisi!')
    .max(10, 'Id Agen tidak boleh melebihi 10 karakter')
    .matches(rgxExp.notSpaceChar, 'Id Agen tidak boleh mrnggunakan spasi')
    .test('unique-code', 'Id Agen sudah digunakan', async (val) => {
      if (!val) return true
      try {
        const res = await apiUseCase.get(`${endpoint}${returnUrlPrams({
          search: val,
          filterField: ['code']
        })}`)
        const filterResult = res.result.filter((x: any) => x.Code === val)
        if (idPrams.value) {
          return filterResult.length === 0 || val === initialValues.IdAgent
        } return filterResult.length === 0
      } catch (error) {
        return false
      }
    }),
  Station: Yup.object().required('Terminal/Halte harus diisi'),
  Location: Yup.object().required('Lokasi harus diisi')
})

const schemaAirport = Yup.object().shape({
  Data: Yup.object().required('Harap pilih agen terlebih dahulu!'),
  Station: Yup.object().required('Terminal/Halte harus diisi'),
})

const onSubmit = (values: any) => {
  console.log('masukk submit', inputSearch.value)
  // eslint-disable-next-line no-use-before-define
  processSubmit(values)
}

const getHjexAgentData = async (setFieldValue: TFieldValue) => {
  const response = await hjexAgentUseCase.getAll({ search: inputSearch.value }, ['name'])
  console.log('resHjex', response.result)
  setFieldValue('Data', response.result.length > 0 ? response.result[0] : null)
}

const onSearch = (setFieldValue: TFieldValue) => {
  console.log('search', inputSearch.value)
  getHjexAgentData(setFieldValue)
}

const onChange = (val: any, setFieldValue: TFieldValue) => {
  console.log('valChange', val)
  setFieldValue('Data', val)
}

const hideSidebar = () => {
  console.log('aaaa')
  store.dispatch('setShowModal', false)
  store.dispatch('setTitleFormSidebar', null)
}

const processSubmit = async (val: any) => {
  store.dispatch('showLoading')
  console.log('val', val)

  if (isNull(store.state.hjpTable.modal.data)) {
    dataForm.value = {
      Name: val.Data ? val.Data?.Name : val.Name,
      Code: val.Data ? val.Data?.Code : val.IdAgent,
      Address: address.value ?? null,
      Longitude: val.Data ? val.Data.Longitude : val.Location.lng,
      Latitude: val.Data ? val.Data.Latitude : val.Location.lat,
      ExternalId: val.Data?.Id ?? null,
      MsCityId: val.Station?.MsCitiesId,
      MsStationId: val.Station?.Id,
      IsActive: val.IsActive
    }
  } else {
    dataForm.value = {
      Id: store.state.hjpTable.modal.data ? store.state.hjpTable.modal.data.Id : '',
      Name: val.Data ? val.Data?.Name : val.Name,
      Code: val.Data ? val.Data?.Code : val.IdAgent,
      Address: address.value ?? null,
      Longitude: val.Data ? val.Data.Longitude : val.Location.lng,
      Latitude: val.Data ? val.Data.Latitude : val.Location.lat,
      ExternalId: val.Data?.Id ?? null,
      MsCityId: val.Station?.MsCitiesId,
      MsStationId: val.Station?.Id,
      IsActive: val.IsActive
    }
  }
  // console.log('dataForm', dataForm.value)
  const response = isNull(store.state.hjpTable.modal.data) ? await apiUseCase.postOrPut(endpoint, null, dataForm.value) : await apiUseCase.postOrPut(endpoint, store.state.hjpTable.modal.data.Id, dataForm.value)
  if (!response.error) {
    $toast.add({
      severity: 'success',
      detail: isNull(store.state.hjpTable.modal.data) ? 'Data Berhasil Ditambahkan' : 'Data Berhasil Diubah',
      group: 'bc',
      closable: false,
      life: 3000
    })
  } else {
    $toast.add({
      severity: 'error',
      detail: isNull(store.state.hjpTable.modal.data) ? 'Data Gagal Ditambahkan' : 'Data Gagal Diubah',
      group: 'bc',
      closable: false,
      life: 3000
    })
  }
  store.dispatch('setShowModal', false)
  store.dispatch('setReloadDataTable', true)
  store.dispatch('setTitleFormSidebar', null)
  store.dispatch('hideLoading')
}

const getLocationFromMaps = (val: any) => {
  address.value = val.formatted_address
}

onMounted(() => {
  console.log('store', store.state)
  let titleForm = 'Tambah'
  if (store.state.hjpTable.modal.data) {
    titleForm = 'Edit'
    if (store.state[moduleStore].modal?.data?.Address) {
      address.value = store.state[moduleStore].modal?.data?.Address
    }
  }
  store.dispatch('setTitleFormSidebar', `${titleForm} Agen`)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_unref(Checkbox), {
          modelValue: isHjexAgent.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((isHjexAgent).value = $event)),
          binary: true,
          inputId: "isHjexAgent"
        }, null, 8, ["modelValue"]),
        _hoisted_4
      ])
    ]),
    _createElementVNode("div", null, [
      _createVNode(_unref(Form), {
        onSubmit: onSubmit,
        "validation-schema": isHjexAgent.value? _unref(schemaAirport) : _unref(schema),
        "initial-values": isHjexAgent.value ? initialValuesAirport : initialValues,
        class: "form-container"
      }, {
        default: _withCtx(({ errors, setFieldValue, values, meta }) => [
          (!isHjexAgent.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _hoisted_7,
                  _createVNode(_unref(Field), { name: "Name" }, {
                    default: _withCtx(({ field, handleChange, handleBlur }) => [
                      _createVNode(_unref(InputText), _mergeProps(field, {
                        modelValue: field.value,
                        onChange: handleChange,
                        onBlur: handleBlur,
                        class: `input-primary ${errors.Name ? 'input-invalid' : ''}`,
                        placeholder: "Ex. Agen BRI",
                        autocomplete: "off",
                        maxlength: 100
                      }), null, 16, ["modelValue", "onChange", "onBlur", "class"])
                    ]),
                    _: 2
                  }, 1024),
                  _createElementVNode("div", _hoisted_8, _toDisplayString(errors.Name), 1)
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _hoisted_10,
                  _createVNode(_unref(Field), { name: "IdAgent" }, {
                    default: _withCtx(({ field, handleChange, handleBlur }) => [
                      _createVNode(_unref(InputText), _mergeProps(field, {
                        modelValue: field.value,
                        onChange: handleChange,
                        onBlur: handleBlur,
                        class: `input-primary ${errors.IdAgent ? 'input-invalid' : ''}`,
                        placeholder: "Ex. 1234567890",
                        autocomplete: "off",
                        maxlength: 10
                      }), null, 16, ["modelValue", "onChange", "onBlur", "class"])
                    ]),
                    _: 2
                  }, 1024),
                  _createElementVNode("div", _hoisted_11, _toDisplayString(errors.IdAgent), 1)
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _hoisted_13,
                  _createVNode(_unref(Field), { name: "Station" }, {
                    default: _withCtx(({ field }) => [
                      _createVNode(SelectFetch, {
                        placeholder: 'Pilih Terminal/Halte',
                        modelValue: values.Station,
                        "onUpdate:modelValue": ($event: any) => ((values.Station) = $event),
                        id: 'station',
                        inputId: 'station',
                        endpoint: "/management/v1/MsStation",
                        classname: 'custom-select',
                        searchCustom: [['activeOnly', '=', true]],
                        fieldLabel: (v) => `${v.CityName} - ${v.Name}`,
                        clearable: false,
                        searchFields: ['name', 'kota']
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "fieldLabel"])
                    ]),
                    _: 2
                  }, 1024),
                  _createElementVNode("div", _hoisted_14, _toDisplayString(errors.Station), 1)
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _hoisted_16,
                  _createVNode(_unref(Field), { name: "Location" }, {
                    default: _withCtx(({ field }) => [
                      _createVNode(MapsSearch, {
                        existLat: field.value?.Lat,
                        existLng: field.value?.Lng,
                        onSendDataLocation: (e) => {
                setFieldValue('Location', { lat: e.latLng.lat().toString(), lng: e.latLng.lng().toString() })
                getLocationFromMaps(e)
              }
                      }, null, 8, ["existLat", "existLng", "onSendDataLocation"])
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _createElementVNode("div", _hoisted_17, [
                  _hoisted_18,
                  _createElementVNode("p", _hoisted_19, _toDisplayString(address.value), 1)
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_20, [
                _createElementVNode("div", _hoisted_21, [
                  _createVNode(SelectFetchHjex, {
                    modelValue: inputSearch.value,
                    "onUpdate:modelValue": [
                      _cache[1] || (_cache[1] = ($event: any) => ((inputSearch).value = $event)),
                      (val) => onChange(val, setFieldValue)
                    ],
                    placeholder: 'Cari Agen',
                    id: 'station',
                    inputId: 'station',
                    endpoint: "/backend/v2/agents",
                    classname: 'custom-select',
                    searchCustom: [['isActive', '=', true]],
                    fieldLabel: (v) => `${v.CityName} - ${v.Name}`,
                    clearable: false,
                    searchFields: ['name']
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "fieldLabel"])
                ]),
                _createElementVNode("div", _hoisted_22, [
                  (inputSearch.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                        _createElementVNode("div", _hoisted_24, [
                          _hoisted_25,
                          _createElementVNode("div", _hoisted_26, [
                            _hoisted_27,
                            _createElementVNode("div", _hoisted_28, _toDisplayString(inputSearch.value?.Name), 1)
                          ]),
                          _createElementVNode("div", _hoisted_29, [
                            _hoisted_30,
                            _createElementVNode("div", _hoisted_31, _toDisplayString(inputSearch.value?.Code), 1)
                          ]),
                          _createElementVNode("div", _hoisted_32, [
                            _hoisted_33,
                            _createElementVNode("div", _hoisted_34, _toDisplayString(inputSearch.value?.Address), 1)
                          ]),
                          _createElementVNode("div", _hoisted_35, [
                            _hoisted_36,
                            _createElementVNode("div", _hoisted_37, _toDisplayString(inputSearch.value?.CityName), 1)
                          ]),
                          _createElementVNode("div", _hoisted_38, [
                            _hoisted_39,
                            _createElementVNode("div", _hoisted_40, _toDisplayString(`${inputSearch.value?.Latitude}, ${inputSearch.value?.Longitude}`), 1)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_41, [
                          _hoisted_42,
                          _createVNode(_unref(Field), { name: "Station" }, {
                            default: _withCtx(({ field }) => [
                              _createVNode(SelectFetch, _mergeProps(field, {
                                placeholder: 'Pilih Terminal/Halte',
                                modelValue: field.value,
                                id: 'station',
                                inputId: 'station',
                                endpoint: "/management/v1/MsStation",
                                classname: 'custom-select',
                                searchCustom: [['activeOnly', '=', true]],
                                fieldLabel: (v) => `${v.CityName} - ${v.Name}`,
                                clearable: false,
                                searchFields: ['name', 'kota']
                              }), null, 16, ["modelValue", "fieldLabel"])
                            ]),
                            _: 1
                          }),
                          _createElementVNode("div", _hoisted_43, _toDisplayString(errors.Station), 1)
                        ])
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_44, "Tidak ada data agen"))
                ]),
                (meta.touched && inputSearch.value.length < 3)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_45, _toDisplayString('Mohon masukkan minimal 3 huruf')))
                  : (meta.touched && !values.Data)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_46, _toDisplayString(errors.Data), 1))
                    : _createCommentVNode("", true)
              ])),
          _createElementVNode("div", _hoisted_47, [
            _hoisted_48,
            _createVNode(_unref(Field), { name: "IsActive" }, {
              default: _withCtx(({ field }) => [
                _createVNode(_unref(InputSwitch), _mergeProps({ class: "input-success" }, field, {
                  modelValue: field.value,
                  "onUpdate:modelValue": ($event: any) => ((field.value) = $event),
                  inputId: "isactive"
                }), null, 16, ["modelValue", "onUpdate:modelValue"])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_49, [
            _createVNode(_unref(Button), {
              class: "btn-back mr-2",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (hideSidebar()))
            }, {
              default: _withCtx(() => [
                _hoisted_50
              ]),
              _: 1
            }),
            _createVNode(_unref(Button), {
              type: "submit",
              class: "btn-primary mr-1"
            }, {
              default: _withCtx(() => [
                _hoisted_51
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      }, 8, ["validation-schema", "initial-values"])
    ])
  ]))
}
}

})